import { render } from "./ColumnGallerySection.vue?vue&type=template&id=22437b8e"
import script from "./ColumnGallerySection.vue?vue&type=script&lang=js"
export * from "./ColumnGallerySection.vue?vue&type=script&lang=js"

import "./ColumnGallerySection.vue?vue&type=style&index=0&id=22437b8e&lang=css"
script.render = render

export default script